import { Link } from 'react-router-dom'

function Terms({ children }) {
    return (
        <div className="terms">
            <small>
                <Link to="/pages/termspolicies">Terms</Link>
                &nbsp;&nbsp;|&nbsp;
                <Link to="/pages/termspolicies">Policies</Link>
                &nbsp;&nbsp;|&nbsp;<Link to="/pages/ccpapolicies">CCPA</Link>
                &nbsp;&nbsp;|&nbsp; <Link to="/pages/faq">FAQ</Link>
                &nbsp;&nbsp;|&nbsp; <Link to="/pages/hours">Hours</Link>
                &nbsp;&nbsp;|&nbsp; <Link to="/donate">Donate</Link>
                &nbsp;&nbsp;|&nbsp;&#169;&nbsp;
                <Link to="/pages/aCo">Agency Couture LLC</Link>&nbsp;
                {new Date().getFullYear()}
            </small>
            <br />
            <br />
            <div>{children}</div>
        </div>
    )
}

export default Terms
